<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="content">
  <div class="title">套餐限制计算</div>
  <div class="subtitle" style="text-align: center">
    比如:您的套餐限制为40次/3小时 (即40次使用次数，每3小时为一个周期)在使用时，
    统计过去3小时内的累计使用次数。如果累计使用次数超过40次,说明已达到上限。
    你可以理解为:
  </div>
  <img
    class="detail"
    src="../../../../assets/images/fleet-package.webp"
    alt=""
  />
  <div class="subtitle">
    每一次使用的次数将在3小时后恢复。在任意3小时内最多可以使用40次。
  </div>
  <div class="tip">
    <img
      src="../../../../assets/images/Icon-zhuyi.svg"
      alt=""
      [width]="20"
      [height]="20"
    />不是每3小时恢复所有使用次数
  </div>
  <div class="button">
    <button (click)="close()">确认</button>
  </div>
</div>
